var _rect, _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherIconCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 12,
    width: 26,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1653 12C28.2195 16.6163 18.1504 34.0033 15.5513 41.8007C14.9739 43.5328 14.4654 45.429 16.1327 42.4049C17.1321 40.5923 19.6053 38.0409 25.2449 37.1255C29.7566 36.3932 31.6458 35.4418 34.5391 32.2052C33.2052 32.6759 31.4823 33.66 27.8043 32.5321C32.9045 32.9728 36.419 29.9977 37.7921 25.7646C34.4247 27.2685 31.5749 26.2162 30.8284 25.8293C35.4219 25.9431 39.296 23.0674 40.2278 18.2778C40.7709 15.4858 39.9009 12.9154 39.1653 12Z",
    fill: "#6160A2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4887 13.3841C26.6153 19.4087 17.9368 34.644 15.5513 41.8007C14.9739 43.5328 14.4654 45.429 16.1327 42.4049C17.1321 40.5923 19.6053 38.0409 25.2449 37.1255C28.9918 36.5173 30.93 35.758 33.1367 33.6641C33.526 33.2947 33.7399 32.5199 33.229 32.6845C32.6368 32.8753 32.0213 32.0638 32.5917 31.8153C34.3813 31.0356 35.7977 29.7002 36.7876 28.0159C37.2698 27.1954 35.5247 26.4868 34.5736 26.5218C33.4088 26.5646 34.3427 25.2941 35.4298 24.8738C36.8816 24.3125 38.2021 23.5199 39.0672 22.5927C40.1935 21.3854 39.8663 20.1358 40.2278 18.2778C40.4709 17.0279 40.4309 15.8224 40.2464 14.79C39.9323 13.0312 38.0138 12.4535 36.4887 13.3841Z",
    fill: "#6160A2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.8875,
    cy: 18.5484,
    r: 14.056,
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.8875,
    cy: 18.5484,
    r: 16.556,
    stroke: "#90DF9B",
    strokeWidth: 5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -58.1685,
    y: -64.5076,
    width: 174.112,
    height: 174.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherIconCircle);
export default __webpack_public_path__ + "static/media/feather-icon-circle.9a5dce9da40c5b4d47c214e389c95ffd.svg";
export { ForwardRef as ReactComponent };